module.exports = __webpack_public_path__ + "resources/img/img_blue_prism1.720483222ac2d049a85ef65276fb611a.png";